/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { ListWithdrawalsOptions, ListWithdrawalsResponses } from '../types/ListWithdrawals'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Lists USDC withdrawals ordered by created_at descending. Non-admin callers are always scoped to their own withdrawals. Admin callers get every user's withdrawals by default, and may narrow to one user with `user_id`. This is also the admin review surface for the withdrawal approval flow: filter with `?status=PENDING` to see the withdrawals awaiting review.
 * @summary List USDC withdrawals
 * {@link /v1/web3/withdrawals}
 */
export function listWithdrawals<ThrowOnError extends boolean = true>(
  options: Options<ListWithdrawalsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListWithdrawalsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/web3/withdrawals',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListWithdrawalsResponses, ThrowOnError>>,
  )
}
